import moment from 'moment';
import {
  QBankPerformanceDataPoint,
  FlashcardTrendDataPoint,
  TopicRadarData,
  FormattedBookmark,
} from '../types/Widgets';

export const QBANK_FAKE_DATA: QBankPerformanceDataPoint[] = [
  {
    date: moment().date(30).subtract(15, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 60,
  },
  {
    date: moment().date(30).subtract(14, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 63,
  },
  {
    date: moment().date(30).subtract(13, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 63,
  },
  {
    date: moment().date(30).subtract(12, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 66,
  },
  {
    date: moment().date(30).subtract(11, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 70,
  },
  {
    date: moment().date(30).subtract(10, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 75,
  },
  {
    date: moment().date(30).subtract(9, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 78,
  },
  {
    date: moment().date(30).subtract(8, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 77,
  },
  {
    date: moment().date(30).subtract(7, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 81,
  },
  {
    date: moment().date(30).subtract(6, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 83,
  },
  {
    date: moment().date(30).subtract(5, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 86,
  },
  {
    date: moment().date(30).subtract(4, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 80,
  },
  {
    date: moment().date(30).subtract(3, 'day').format('YYYY-MM-DD'),
    correctCount: 9,
    incorrectCount: 1,
    omittedCount: 0,
    score: 80,
  },
  {
    date: moment().date(30).subtract(2, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 1,
    omittedCount: 1,
    score: 85,
  },
  {
    date: moment().date(30).subtract(1, 'day').format('YYYY-MM-DD'),
    correctCount: 8,
    incorrectCount: 2,
    omittedCount: 0,
    score: 87,
  },
  {
    date: moment().date(30).format('YYYY-MM-DD'),
    correctCount: 9,
    incorrectCount: 0,
    omittedCount: 1,
    score: 92,
  },
];

export const FLASHCARD_TREND_FAKE_DATA: FlashcardTrendDataPoint[] = [
  {
    date: moment().date(30).subtract(10, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 55,
  },
  {
    date: moment().date(30).subtract(9, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 43,
  },
  {
    date: moment().date(30).subtract(8, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 36,
  },
  {
    date: moment().date(30).subtract(7, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 50,
  },
  {
    date: moment().date(30).subtract(6, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 55,
  },
  {
    date: moment().date(30).subtract(5, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 43,
  },
  {
    date: moment().date(30).subtract(4, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 39,
  },
  {
    date: moment().date(30).subtract(3, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 50,
  },
  {
    date: moment().date(30).subtract(2, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 46,
  },
  {
    date: moment().date(30).subtract(1, 'day').format('YYYY-MM-DD'),
    completedFlashcardCount: 33,
  },
];

export const TOPIC_RADAR_FAKE_DATA: TopicRadarData = {
  MSK: {
    correct: 10,
    total: 10,
    percentage: 90,
  },
  Endo: {
    correct: 10,
    total: 10,
    percentage: 87,
  },
  Basic: {
    correct: 10,
    total: 10,
    percentage: 92,
  },
  GI: {
    correct: 10,
    total: 10,
    percentage: 60,
  },
  Derm: {
    correct: 10,
    total: 10,
    percentage: 54,
  },
  Repro: {
    correct: 10,
    total: 10,
    percentage: 70,
  },
  Renal: {
    correct: 10,
    total: 10,
    percentage: 65,
  },
  Cardio: {
    correct: 10,
    total: 10,
    percentage: 70,
  },
  Psych: {
    correct: 10,
    total: 10,
    percentage: 69,
  },
  Neuro: {
    correct: 10,
    total: 10,
    percentage: 55,
  },
  Heme: {
    correct: 10,
    total: 10,
    percentage: 50,
  },
  Pulm: {
    correct: 10,
    total: 10,
    percentage: 67,
  },
  Immune: {
    correct: 10,
    total: 10,
    percentage: 78,
  },
  Ethics: {
    correct: 10,
    total: 10,
    percentage: 85,
  },
  ID: {
    correct: 10,
    total: 10,
    percentage: 90,
  },
};

export const BOOKMARK_FAKE_DATA: FormattedBookmark[] = [
  {
    id: '1',
    title: 'Dandy-Walker Malformation',
    type: 'article',
    dateAdded: moment().format('YYYY-MM-DD'),
  },
  {
    id: '2',
    title: 'Systemic Lupus Erythematosus',
    type: 'article',
    dateAdded: moment().format('YYYY-MM-DD'),
  },
  {
    id: '3',
    title: 'Gallstones',
    type: 'video',
    dateAdded: moment().format('YYYY-MM-DD'),
  },
  {
    id: '4',
    title: 'Type II Hypersensitivity',
    type: 'video',
    dateAdded: moment().format('YYYY-MM-DD'),
  },
  {
    id: '5',
    title: 'Branchial Cleft Cysts',
    type: 'article',
    dateAdded: moment().format('YYYY-MM-DD'),
  },
];
